import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import DefaultButton from '../../../../global/default-button/default-button';
import { DefaultCloseModalButton } from '../../../../global/modal/common/common-close-modal-buttons';
import { ReportConfigurationViewModel } from './report-configuration.viewmodel';
import SaveConfigurationBody from '../../shared/save-view-form/save-configuration-body';
import { ISelectableFilter, ReportConfigurationTarget } from '../../../../../api/reports.dao';
import { FormField } from '../../../../global/form/form-field/form-field';
import { OERadioOptions } from '../../../../global/oe-radio-options/oe-radio-options';
import { getReportFilterText } from '../../../../../infrastructure/utils/report.utils';
import { cancelText } from '../../../../../constants/common-labels.constants';

interface IProps {
    vm: ReportConfigurationViewModel;
    intl: IntlShape;
    availableFilterTypes: ISelectableFilter[];
}

const ReportConfigurationPresentation = injectIntl(mobxReact.observer((props: IProps) => {
    const { vm, intl, availableFilterTypes } = props;

    const getMappedAppliedFilters = () => {
        return vm.getAppliedFiltersForSave().map(filter => ({
            filterName: availableFilterTypes.find(el => el.field === filter.field).label,
            filterValues: [{
                id: filter.field,
                label: getReportFilterText(availableFilterTypes.find(el => el.field === filter.field), filter)
            }]
        }));
    };

    return (
        <CommonModal
            title={
                <FormattedMessage
                    id='oe.reports.saveReportConfiguration'
                    description='Modal header text'
                    defaultMessage='Save Report Configuration'
                />
            }
            classNameBody='save-configuration__modal-body'
            isOpen={true}
            onRequestClose={() => vm.setAddingNewModalClose()}
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultButton
                        disabled={vm.isSavingNewConfiguration}
                        text={
                            <FormattedMessage
                                id='oe.common.save'
                                defaultMessage='Save'
                                description='Button text'
                            />
                        }
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.saveConfiguration}
                    />
                    <DefaultCloseModalButton text={cancelText()} />
                </div>
            }
        >
            <SaveConfigurationBody
                label={<FormattedMessage
                    id='oe.reports.title'
                    defaultMessage='Report Configuration Name'
                    description='Label text'
                />}
                nameValue={vm.configurationLabel}
                handleChangeNameValue={vm.setConfigurationLabel}
                getNameError={() => vm.isSubmitted && vm.getConfigurationLabelError()}
                columns={vm.getAvailableColumns()
                    .filter(el => el.enabled && !el.customField)
                    .map(el => el.label)
                }
                selectedFilters={getMappedAppliedFilters()}
                layoutType={vm.withLayout && vm.layoutType}
            >
                <div className='oe-form__row'>
                    <FormField className='m-bottom-18px'>
                        <OERadioOptions
                            options={[
                                {
                                    value: ReportConfigurationTarget.USER,
                                    label: intl.formatMessage({
                                        id: 'oe.save-configuration.user',
                                        defaultMessage: 'Save to My Configurations'
                                    })
                                },
                                {
                                    value: ReportConfigurationTarget.ACCOUNT,
                                    label: intl.formatMessage({
                                        id: 'oe.save-configuration.user',
                                        defaultMessage: 'Save to Account Configurations'
                                    })
                                }
                            ]}
                            value={vm.configurationTarget}
                            onOptionToggle={(value: ReportConfigurationTarget) => vm.onChangeConfigurationStore(value)}
                            styles='website-custom__radio column'
                        />
                    </FormField>
                </div>
            </SaveConfigurationBody>
        </CommonModal>
    );
}));

export { ReportConfigurationPresentation };
